module.exports = __webpack_public_path__ + "static/media/atlas.84078488.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/atlas.png
// module id = 157
// module chunks = 0